import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IChatMessageSeen } from '@/shared/model/chat/chat-message-seen.model';

const baseApiUrl = 'api/chat-message-seens';

export default class ChatMessageSeenService {
  public find(id: number): Promise<IChatMessageSeen> {
    return new Promise<IChatMessageSeen>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrievePaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IChatMessageSeen): Promise<IChatMessageSeen> {
    return new Promise<IChatMessageSeen>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IChatMessageSeen): Promise<IChatMessageSeen> {
    return new Promise<IChatMessageSeen>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public setLoopReedByChatId(chatId: number): Promise<IChatMessageSeen> {
    return new Promise<IChatMessageSeen>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/read-loop/chat/${chatId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public setReedByChatMessageId(chatId: number, chatMessageId: number): Promise<IChatMessageSeen> {
    return new Promise<IChatMessageSeen>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/read/chat-message/${chatId}/${chatMessageId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
